<template>
  <div class="sub-admin-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="title-line">
        <span class="line"></span>
        <span class="title">子管理员设置</span>
      </div>
    </div>

    <!-- 管理员列表展示（仅显示子管理员） -->
    <el-table 
      :data="stageListFiltered" 
      border 
      style="width: 100%;" 
      class="admin-table"
    >
      <!-- 学段列 -->
      <el-table-column label="学段" align="center" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.label }}
        </template>
      </el-table-column>
    
      <!-- 当前管理员列 -->
      <el-table-column label="当前管理员" align="center" min-width="200">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            class="teacher-btn"
            @click="openSetDialog(scope.row.value)"
          >
            {{ sectionAdminMap[scope.row.value] || '设置' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 设置管理员弹窗（复用教师设置弹窗逻辑） -->
    <el-dialog title="设置子管理员" :visible.sync="dialogVisible" width="550px" :append-to-body="true"
		  	:loading="dialogLoading">
      <!-- 搜索选择用户 -->
      <el-select
        v-model="selectedAdminId"
        placeholder="请选择要设置为子管理员的用户"
        filterable
        remote
        :remote-method="searchUser"
        style="width: 100%; margin-bottom: 15px;"
        clearable
      >
        <el-option
          v-for="user in userList"
          :key="user.id"
          :label="user.name"
          :value="user.id"
        ></el-option>
      </el-select>

      <!-- 已选管理员 -->
      <div v-if="selectedAdminId" style="padding: 10px; background: #f7f8fa; border-radius: 6px;">
        已选用户：<b>{{ getSelectedUserName() }}</b>
        <el-button type="success" size="mini" @click="saveAdmin" style="margin-left: 10px;">
          确认设置
        </el-button>
      </div>

      <!-- 当前任职管理员 & 可删除 -->
      <div style="margin-top: 15px;">
        <div style="font-weight: bold; margin-bottom: 8px;">当前子管理员：</div>
        <el-tag
          v-for="item in currentAdminList"
          :key="item.id"
          type="primary"
          closable
          @close="deleteAdmin(item.id)"
          style="margin-right: 8px; margin-bottom: 8px;"
        >
          {{ item.teacherName }}
        </el-tag>
        <div v-if="currentAdminList.length === 0" style="color: #999;">暂无子管理员</div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SubAdmin",
  data() {
    return {
      adminAssignList: [{ roleType: 2, roleName: "子管理员" }],
      dialogVisible: false,
      userList: [],
      selectedAdminId: null,
      schoolId: localStorage.getItem('orgId'),
      currentAdminList: [],
      schoolInfo: {},
      // 学段
      stageList: [
        { label: '小学', value: 1 },
        { label: '初中', value: 2 },
        { label: '高中', value: 3 }
      ],
      // 学段 -> 管理员名称
      sectionAdminMap: {} 
    };
  },
  computed: {
    stageListFiltered() {
      if (!this.schoolInfo.stages) return []
      return this.stageList.filter(item => 
        this.schoolInfo.stages.includes(item.value.toString())
      )
    }
  },
  created() {
    this.getSchoolId()
  },
  methods: {
    getSchoolId() {
      this.API.get(this.API.school.getSchoolId + this.schoolId).then(res => {
        if (res.data.code == 200) {
          this.schoolInfo = res.data.data
          this.loadAllSectionAdmins() 
        } else {
          alert('学校加载失败')
        }
      })
    },

    // 一次性加载所有学段的管理员
    loadAllSectionAdmins() {
      this.API.get(this.API.school.getSchoolAdminList, {
        schoolId: this.schoolId,
        roleType: 2,
		sectionId:''
      }).then(res => {
        if (res.data.code === 200) {
          const list = res.data.data || []
          const map = {}

          list.forEach(item => {
            const sid = item.sectionId
            if (!map[sid]) map[sid] = []
            map[sid].push(item.teacherName)
          })

          const result = {}
          for (let k in map) {
            result[k] = map[k].join(' | ')
          }
          this.sectionAdminMap = result
        }
      })
    },

    // 打开弹窗（带入学段）
    openSetDialog(sectionId) {
      this.currentSectionId = sectionId
      this.API.get(this.API.school.getSchoolAdminList, {
        schoolId: this.schoolId,
        roleType: 2,
        sectionId: sectionId
      }).then(res => {
        if (res.data.code == 200) {
          this.currentAdminList = res.data.data
          this.selectedAdminId = null
          this.dialogVisible = true
        }
      })
    },

    // 远程搜索用户
    searchUser(key) {
      const name = key || ''
      this.API.get(this.API.school.getSchoolSearch, {
        pageNum: 1,
        pageSize: 100,
        schoolId: this.schoolId,
        name: name
      }).then(res => {
        this.userList = res.data.data.records
      })
    },

    // 获取选中用户名
    getSelectedUserName() {
      const user = this.userList.find(u => u.id == this.selectedAdminId)
      return user ? user.name : ""
    },

    // 保存（带入学段）
    saveAdmin() {
      if (!this.selectedAdminId) {
        return this.$message.warning("请选择要设置的用户")
      }
      if (!this.currentSectionId) {
        return this.$message.warning("请先选择学段")
      }

      const params = {
        userId: this.selectedAdminId,
        schoolId: this.schoolId,
        roleType: 2,
        sectionId: this.currentSectionId
      }

      this.API.post(this.API.school.postAssignSave, params).then(res => {
        if (res.data.code === 500) {
          this.$message.error(res.data.msg)
        } else {
          this.$message.success("设置成功")
          this.loadAllSectionAdmins() 
          this.openSetDialog(this.currentSectionId)
          this.selectedAdminId = null
        }
      })
    },

    // 删除
    deleteAdmin(id) {
      this.API.deleted(this.API.school.deletedAssign + id).then(() => {
        this.$message.success("已取消任职")
        this.loadAllSectionAdmins()
        this.openSetDialog(this.currentSectionId)
      })
    }
  }
};
</script>

<style scoped>
.sub-admin-page {
	width: calc(60vw);
  padding: 15px;
}

.page-header {
  margin-bottom: 20px;
}

.title-line {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.line {
  display: inline-block;
  width: 3px;
  height: 16px;
  background-color: #1e88e5;
  margin-right: 8px;
}

.title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.admin-table /deep/ th {
  background-color: #1e88e5;
  color: #fff;
}

/deep/ .el-button--text {
  color: #1e88e5;
}

.teacher-btn {
  max-width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>